import { t } from "@/lib/i18n";

const toWhatsAppText = (md) =>
  md
    .replace(/^#{1,6}\s*(.+)$/gm, "*$1*")
    .replace(/\*\*(.+?)\*\*/g, "*$1*")
    .replace(/^\s*[-*]\s*\[\s?\]\s*/gm, "☐ ")
    .replace(/^\s*[-*]\s*\[x\]\s*/gim, "☑ ")
    .replace(/^\s*[-*]\s+/gm, "• ")
    .replace(/\[(.+?)\]\((.+?)\)/g, "$1 ($2)")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

export const buildWhatsAppUrl = ({ question, answer, locationLabel }) => {
  const parts = [
    `*${t("wa.title")}*`,
    "",
    `*${t("wa.case")}:* ${question}`,
    locationLabel ? `*${t("wa.loc")}:* ${locationLabel}` : null,
    "",
    toWhatsAppText(answer),
    "",
    `_${t("wa.disclaimer")}_`,
  ].filter((p) => p !== null);
  return `https://wa.me/?text=${encodeURIComponent(parts.join("\n"))}`;
};
